module.exports = __webpack_public_path__ + "img/keybord.c9078df2.svg";